(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .constant('flyersConstants', {
            FLYER_ACTION: {
                HOTSITE: 'HOTSITE',
                LINK: 'LINK',
                SEND: 'SEND',
                EDIT: 'EDIT',
                DELETE: 'DELETE',
                DUPLICATE: 'DUPLICATE',
                RECOMMEND: 'RECOMMEND',
                PUBLISH: 'PUBLISH',
                UNPUBLISH: 'UNPUBLISH',
                CLOSE_DETAILS_MODAL: 'CLOSE_DETAILS_MODAL'
            },
            FLYER_DETAIL_ITEMS_STATE: {
                VARIATIONS: 'VARIATIONS',
                PICTURES: 'PICTURES'
            },
            FLYER_DETAIL_PICTURES_STATE: {
                PICTURES: 'PICTURES',
                BLUEPRINTS: 'BLUEPRINTS'
            },
            SELECT_OPTIONS: {
                RETAIL: {
                    CONFIGURATIONS: [
                        {id: 1, label: 'flyers.new.form.configurations.launch', code: 'launch'},
                        {id: 2, label: 'flyers.new.form.configurations.basic', code: 'basic'}
                    ],
                    GENDERS: [
                        { id: 1, label: 'flyers.new.form.gender.male' },
                        { id: 2, label: 'flyers.new.form.gender.female' },
                        { id: 3, label: 'flyers.new.form.gender.both' }
                    ],
                    IMAGE_OPTIONS: [
                        { id: 1, label: 'flyers.new.form.images.both', value:'BOTH' },
                        { id: 2, label: 'flyers.new.form.images.with_image', value:'WITH_IMAGE' },
                        { id: 3, label: 'flyers.new.form.images.no_image', value:'NO_IMAGE' }
                    ],
                    HUB_SYNC_OPTIONS: [
                        { id: 1, label: 'flyers.filters.hubSync.both', value: null },
                        { id: 2, label: 'flyers.filters.hubSync.synced', value: 'SYNCED' },
                        { id: 3, label: 'flyers.filters.hubSync.notSynced', value: 'NOT_SYNCED' }
                    ]
                },
                IMMO: {
                    CONFIGURATIONS: [
                        {id: 1, label: 'flyers.new.form.configurations.launch', code: 'launch'},
                        {id: 2, label: 'flyers.new.form.configurations.basic-immo', code: 'basic'},
                        {id: 3, label: 'flyers.new.form.configurations.delivered', code: 'delivered'}
                    ],
                    SELECT_FIVE: [
                        { id: 1, label: '1', value: 1 },
                        { id: 2, label: '2', value: 2 },
                        { id: 3, label: '3', value: 3 },
                        { id: 4, label: '4', value: 4 },
                        { id: 5, label: '5+', value: 5 },
                    ]
                }
            }
        });
})();
